import { breadcrumb } from './breadcrumb';
import { campaign } from './campaign';
import { stats } from './stats';
import { worksheets } from './worksheets';

export const autoinformer = {
  breadcrumb,
  campaign,
  stats,
  worksheets,

  task: {
    status: {
      success: 'Успех',
      pending: 'В очереди',
      processing: 'Выполняется',
      fail: 'Неудача'
    },

    create: 'Создать задачу',

    button: {
      create: 'Добавить задачу'
    },

    field: {
      number: 'Телефон'
    },

    table: {
      field: {
        attempts: 'Попытки',
        last_attempt: 'Последняя попытка'
      }
    },

    modal: {
      remove: {
        content: `Вы действительно хотите удалить задачу с номером <b>{number}</b>?`
      }
    }
  },
  validator: {
    field: {
      calls_limit: {
        max_value: 'Предиктивный обзвон поддерживает не более 30 одновременных соединений.'
      },
      date_time_error: 'Время указывается позже текущего в UTC +00:00'
    },
    empty_mediafiles: 'Проверьте схему. Все элементы "Медиа файл" и "IVR-меню" на схеме должны быть с аудиофайлом'
  },
};
